/* Carousels (bestsellers, recently viewed): small arrows next to the title, like alohagaia.ru */
(() => {
  const run = () => {
    document.querySelectorAll('[id*="__bestsellers"], [id*="recently-viewed"]').forEach((sec) => {
      const head = sec.querySelector('.section-stack > .section-header, .section-stack > .v-stack');
      const cands = [...sec.querySelectorAll('scroll-carousel, .product-list--carousel, .scroll-area')];
      const track = cands.find((el) => el.scrollWidth > el.clientWidth + 2) || cands[0];
      if (!head || !track || head.querySelector('.ru-arrows')) return;
      const box = document.createElement('div');
      box.className = 'ru-arrows';
      box.innerHTML = '<button type="button" aria-label="previous"><span class="l"></span></button><button type="button" aria-label="next"><span class="r"></span></button>';
      head.appendChild(box);
      const [prev, next] = box.querySelectorAll('button');
      const step = () => { const c = track.querySelector('product-card, .product-card'); return c ? c.getBoundingClientRect().width + 8 : track.clientWidth; };
      const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      setTimeout(update, 500);
      update();
    });
  };
  const start = () => { run(); [800, 2000, 4000].forEach((t) => setTimeout(run, t)); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
